import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { loginSuccess } from "./redux/slices/userSlice";
import Login from "./pages/login/Login";
import ForgotPassword from "./pages/forgotpassword/ForgotPassword";
import Home from "./pages/home/home";
import Monitoring from "./components/monitoring/Monitoring";
import { GoogleOAuthProvider } from "@react-oauth/google";
import QRtrack from "./pages/qrtrack/QRtrack";
import DeeplinkHandler from "./pages/qrtrack/Deeplinkhandler";
import TatReport from "./components/report/reporttabs/TatReport";
import QrDetailsPage from "./pages/qrtrack/QrDetailsPage";

const App = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));
    if (token && user) {
      dispatch(loginSuccess({ user, token }));
    }
  }, [dispatch]);

  return (
    <GoogleOAuthProvider clientId="693705214466-td3ie8rr1236lutavhnpv7krhl9l95m8.apps.googleusercontent.com">
      <Router>
        <Routes>
          {/* If the user is logged in, redirect to home page */}
          <Route
            path="/"
            element={isLoggedIn ? <Navigate to="/home" /> : <Login />}
          />

          {/* Public route for Forgot Password */}
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/monitoring" element={<Monitoring />} />
          <Route path="/tat-report" element={<TatReport />} />
          <Route path="/track/:loc_id" element={<QRtrack />} />
          <Route path="/deeplink?loc_id=xxx" element={<DeeplinkHandler />} />
          <Route path="/qr/:qr_id/details" element={<QrDetailsPage />} />



          {/* Protected Route for Home - only accessible when logged in */}
          <Route
            path="/home"
            element={isLoggedIn ? <Home /> : <Navigate to="/" />}
          />

          {/* Catch-all route: if the user is not logged in, they can't access any page except login */}
          <Route
            path="*"
            element={isLoggedIn ? <Navigate to="/home" /> : <Navigate to="/" />}
          />
        </Routes>
      </Router>
    </GoogleOAuthProvider>
  );
};

export default App;
